import { Columns } from '@domain-group/suit-theme'

import { useNumericParams } from '@domain-group/react-hooks'

import CampaignInspections from '@components/CampaignInspections'
import Documents from '@components/Documents'
import NotificationBannerLocation from '@components/NotificationBannerLocation'
import NotificationModuleLocation from '@components/NotificationModuleLocation'
import ToursAndLinks from '@components/ToursAndLinks'

import useCampaign from '@hooks/useCampaign'
import useCampaignCategories from '@hooks/useCampaignCategories'
import useCampaignCommercialCategories from '@hooks/useCampaignCommercialCategories'
import useCampaignRuralCategories from '@hooks/useCampaignRuralCategories'
import useDataStoreItems from '@hooks/useDataStoreItems'

import PortalDataTools from '../PortalDataTools'
import PageLayout from '../PageLayout'

import BasicFeatures from '../BasicFeatures'
import Images from '../Images'
import LandDetails from '../LandDetails'
import ListingCategory from '../ListingCategory'
import ListingDetails from '../ListingDetails'
import ListingStatus from '../ListingStatus'
import PropertyAddress from '../PropertyAddress'

const PageContent = () => {
  const { campaignId } = useNumericParams()

  useCampaignCategories({ performHttpRequests: !!campaignId })
  useCampaignCommercialCategories({ performHttpRequests: !!campaignId })
  useCampaignRuralCategories({ performHttpRequests: !!campaignId })

  useDataStoreItems(
    {
      filters: { owner_id: campaignId, owner_type: 'Campaign' },
      performHttpRequests: !!campaignId,
    },
  )

  const campaignPayload = useCampaign({ id: campaignId })

  const {
    campaign,
  } = campaignPayload

  return (
    <PageLayout campaignPayload={campaignPayload}>
      <Columns.Main>
        <NotificationBannerLocation locationKey="agency.campaign.portalData.banner" />

        <ListingCategory />

        <ListingDetails />

        <ListingStatus />

        <PropertyAddress />

        <LandDetails />

        <BasicFeatures />
      </Columns.Main>

      <Columns.Sidebar>
        <NotificationModuleLocation locationKey="agency.campaign.portalData.sidebar" />

        <PortalDataTools campaignPayload={campaignPayload} />

        <Images />

        <CampaignInspections campaign={campaign} readOnly />

        <ToursAndLinks campaign={campaign} readOnly />

        <Documents campaign={campaign} readOnly />
      </Columns.Sidebar>
    </PageLayout>
  )
}

export default PageContent
